module.exports = __webpack_public_path__ + "media/images/pin-c9c7d96f54a46e4ab9c4deb9dc22bd98.svg";